/* eslint no-unused-vars: 0 */
import { html, svg, repeat, classMap, styleMap, ifDefined, unsafeHTML, scopeTag } from "@ui5/webcomponents-base/dist/renderer/LitRenderer.js";
import { getCustomElementsScopingSuffix } from "@ui5/webcomponents-base/dist/CustomElementsScopeUtils.js";
import type UI5Element from "@ui5/webcomponents-base/dist/UI5Element.js";
import type TableHeaderCell from "../../TableHeaderCell.js";
import type { ClassMapValue } from "@ui5/webcomponents-base/dist/types.js";
	
function block0 (this: TableHeaderCell, context: UI5Element, tags: string[], suffix: string | undefined) { return html`<slot></slot>`;}

function template(this: TableHeaderCell) { return block0.call(this, this, (this.constructor as typeof UI5Element).tagsToScope, getCustomElementsScopingSuffix()); }
export default template;